import React from "react";
import { Award, ShieldCheck, Leaf, Truck } from "lucide-react";
import { clients, associations } from "../data/mock";

const associationIcons = {
  BHSEA: ShieldCheck,
  CECA: Award,
  FTA: Truck,
  "Greener Highways": Leaf
};

function Plate({ name }) {
  return (
    <div className="shrink-0 group">
      <div className="flex items-center justify-center h-16 lg:h-20 min-w-[180px] lg:min-w-[220px] px-7 rounded-xl border border-white/8 bg-white/[0.02] backdrop-blur-sm transition-all duration-300 group-hover:border-[#F5D000]/40 group-hover:bg-white/[0.04]">
        <span className="font-display text-base lg:text-lg font-semibold tracking-tight text-white/55 group-hover:text-white whitespace-nowrap transition-colors">
          {name}
        </span>
      </div>
    </div>
  );
}

function Row({ items, reverse = false }) {
  return (
    <div className="marquee-mask overflow-hidden">
      <div className={`flex gap-5 lg:gap-6 w-max ${reverse ? "animate-marquee-slow" : "animate-marquee"}`}>
        {[...items, ...items].map((c, i) => (
          <Plate key={i} name={c.name} />
        ))}
      </div>
    </div>
  );
}

export default function ClientsMarquee() {
  const half = Math.ceil(clients.length / 2);
  const row1 = clients.slice(0, half);
  const row2 = clients.slice(half);

  return (
    <section id="clients" className="relative py-24 lg:py-28 bg-[#0a0a0c]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-14 reveal">
          <div className="text-[11px] uppercase tracking-[0.3em] text-amber-accent mb-4">Trusted By</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] max-w-3xl mx-auto">
            Partnering with the UK's <span className="text-amber-accent">most ambitious</span> contractors &amp; authorities.
          </h2>
        </div>

        <div className="space-y-5">
          <Row items={row1} />
          <Row items={row2} reverse />
        </div>

        {/* Associations */}
        <div className="mt-20 pt-12 border-t border-white/5">
          <div className="text-center mb-10 reveal">
            <div className="text-[11px] uppercase tracking-[0.3em] text-white/55">Association Members</div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 max-w-5xl mx-auto">
            {associations.map((a, i) => {
              const Icon = associationIcons[a.name] || Award;
              return (
                <div
                  key={a.name}
                  className="reveal flex flex-col items-center gap-3 p-6 rounded-xl border border-white/8 bg-white/[0.02] hover:border-[#F5D000]/40 transition-all group"
                  style={{ transitionDelay: `${i * 100}ms` }}
                >
                  <div className="w-12 h-12 rounded-lg bg-[#F5D000]/10 border border-[#F5D000]/30 flex items-center justify-center group-hover:bg-[#F5D000] transition-colors">
                    <Icon className="w-5 h-5 text-[#F5D000] group-hover:text-black" />
                  </div>
                  <div className="text-center">
                    <div className="font-display font-bold text-white text-lg">{a.name}</div>
                    <div className="text-[10px] uppercase tracking-[0.22em] text-white/45 mt-1">{a.sub}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
